import { Common } from './common';
import { EncounterProblem } from './models/problemGroup';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async exportedToEhr(encounterId: string): Promise<{ success: boolean }> {
    const url = this.common.constructPath(
      `/problemGroups/exportedToEhrManually`,
    );
    return this.common.postJSON(url, { encounterId });
  }

  async exportToEhr(encounterId: string): Promise<{ success: boolean }> {
    const url = this.common.constructPath(`/problemGroups/exportToEhr`);
    return this.common.postJSON(url, { encounterId });
  }

  async findAllByEncounterId(encounterId: string): Promise<EncounterProblem[]> {
    const url = this.common.constructPath(`/problemGroups/${encounterId}`);
    return this.common.getJSON(url);
  }
}
